import { render, staticRenderFns } from "./template18.vue?vue&type=template&id=f218b08c&scoped=true"
import script from "./template18.vue?vue&type=script&lang=js"
export * from "./template18.vue?vue&type=script&lang=js"
import style0 from "./template18.vue?vue&type=style&index=0&id=f218b08c&prod&scoped=true&lang=scss"
import style1 from "./template18.vue?vue&type=style&index=1&id=f218b08c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f218b08c",
  null
  
)

export default component.exports